import { API_BASE } from 'helpers/api'

/**
 * KORXONA BRENDI — yon paneldagi nom/logotip.
 *
 * ⚠️ NEGA KERAK: ilgari yon panelda bitta tenant logotipi turardi va uni BARCHA
 *    tenant ko'rardi — jumladan bir-biriga raqobatchi korxonalar. Endi har kim
 *    o'zinikini ko'radi.
 *
 * Zaxira zanjiri: LOGOTIP -> korxona NOMI (matn) -> ilova belgisi.
 * Begona rasm hech qachon ko'rsatilmaydi.
 *
 * Ma'lumot kirish javobidan keladi (`pos_name`, `pos_logo`) va localStorage da
 * saqlanadi — yon panel har sahifada chiziladi, so'rov kutib turmasin.
 */

const STORAGE_KEY = 'pos_brand'

let cache = null

export function saveBrand(posName, posLogo) {
	cache = { name: posName || '', logo: posLogo || '' }
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(cache))
	} catch (e) { /* jim */ }
	return cache
}

export function getBrand() {
	if (cache) return cache
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (raw) {
			cache = JSON.parse(raw)
			return cache
		}
	} catch (e) { /* jim */ }
	return { name: '', logo: '' }
}

/** Logotip manzili — yo'q bo'lsa null (u holda nom matn bilan chiqadi) */
export function brandLogoUrl() {
	const b = getBrand()
	return b.logo ? API_BASE + '/uploads/poses/' + b.logo : null
}

/** Ko'rsatiladigan nom (logotip bo'lmaganda) */
export function brandName() {
	return getBrand().name || ''
}
